import { useState } from 'react';
import Dynamic from 'next/dynamic';
import { Box, Typography } from '@mui/material';

import { Swiper, SwiperSlide } from 'components/Shared/Swiper';
import Testimony from 'components/CMSComponents/Testimonies/Testimony';
import CustomContainer from 'components/Shared/CustomContainer';

import { testimoniesContentShape } from 'components/CMSComponents/Testimonies/props';

import { testimoniesContent } from 'mocks/cms/testimonies';

import * as Styles from './styles';

const TestimonyVideo = Dynamic(
  () => import('components/CMSComponents/Testimonies/Testimony/TestimonyVideo'),
  {
    ssr: false,
  }
);

Testimonies.propTypes = {
  content: testimoniesContentShape,
};

Testimonies.defaultProps = {
  content: testimoniesContent,
};

export default function Testimonies({ content }) {
  const [openDialog, setOpenDialog] = useState(false);
  const [currentPerson, setCurrentPerson] = useState(content?.testimonies[0]);
  const isPrimarySwiperColor = content?.carouselColor === '#ED6A6D';

  const closeDialog = () => setOpenDialog(false);

  const handleDialog = (person) => {
    setCurrentPerson(person);
    setOpenDialog(!openDialog);
  };

  return (
    <Box
      component="section"
      id="depoimentos"
      bgcolor={content?.backgroundColor}
    >
      <CustomContainer>
        <Typography component="h3" variant="h4" sx={Styles.SectionTitle}>
          {content?.title}
        </Typography>

        <Swiper
          pagination={{ clickable: true, dynamicBullets: true }}
          navigation
          isPrimaryColor={isPrimarySwiperColor}
          alternativeColor={
            isPrimarySwiperColor ? '#FFFFFF' : content?.carouselColor
          }
          loop={content?.testimonies.length >= 8}
          breakpoints={{
            768: {
              slidesPerView: 1,
            },
            960: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1268: {
              slidesPerView: 3,
              spaceBetween: 32,
            },
            1920: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
          }}
        >
          {content?.testimonies.map((person) => (
            <SwiperSlide key={`${person.videoURL}-key`}>
              <Testimony
                handleDialog={handleDialog}
                config={content?.testimonyConfig}
                person={person}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {openDialog && (
          <TestimonyVideo
            openDialog={openDialog}
            person={currentPerson}
            closeDialog={closeDialog}
          />
        )}
      </CustomContainer>
    </Box>
  );
}
